// extracted by mini-css-extract-plugin
module.exports = {"capacityInfo":"capacity-info_capacityInfo__LsVqa"};